import { gql } from "@apollo/client";

export const verifyPayment = gql`
query verifyAccountDetails($input: PaystackValidateAccountInput!) {
  verifyAccountDetails(input: $input)
}
`;

export const getSupplierTransactionReference = gql`
  query GetStorefrontTransaction($input: GetStorefrontTransactionsInput!) {
  getStorefrontTransaction(input: $input) {
    id
    reference
    amount
    direction
    type
    status
    metadata
    created_at
    updated_at
  }
}
`;